/**
 * ChartStyles
 * 
 * Configurações de cores e estilos para gráficos Recharts
 */

export const chartColors = {
   primary: '#4098ef',
   success: '#4caf50',
   warning: '#ff9800',
   danger: '#f44336',
   purple: '#9c27b0',
   teal: '#009688',
   cyan: '#00bcd4',
   indigo: '#3f51b5',
   gray: '#9e9e9e',
};

export const chartTheme = {
   // Cores das linhas
   lineColors: [
      chartColors.primary,
      chartColors.success,
      chartColors.warning,
      chartColors.purple,
      chartColors.teal,
   ],

   // Grid
   gridColor: '#e0e0e0',
   gridOpacity: 0.3,

   // Tooltip
   tooltipBackground: '#ffffff',
   tooltipBorder: '#e0e0e0',
   tooltipShadow: '0 2px 8px rgba(0,0,0,0.15)',

   // Axes
   axisColor: '#666',
   axisFontSize: 12,
   axisFontFamily: "'Noto Sans', sans-serif",

   // Legend
   legendFontSize: 13,
   legendColor: '#333',
};

export const defaultChartConfig = {
   margin: { top: 5, right: 30, left: 20, bottom: 5 },
};

export const tooltipStyle = {
   contentStyle: {
      backgroundColor: chartTheme.tooltipBackground,
      border: `1px solid ${chartTheme.tooltipBorder}`,
      borderRadius: '8px',
      boxShadow: chartTheme.tooltipShadow,
      padding: '12px',
   },
   labelStyle: {
      color: chartTheme.legendColor,
      fontWeight: 600,
      marginBottom: '8px',
   },
   itemStyle: {
      color: chartTheme.axisColor,
      fontSize: '13px',
   },
};

export const axisStyle = {
   fontSize: chartTheme.axisFontSize,
   fontFamily: chartTheme.axisFontFamily,
   fill: chartTheme.axisColor,
};
